module.exports = "  <!-- <pagesnavbar-cmp></pagesnavbar-cmp> -->\n  <router-outlet></router-outlet>\n  <!-- <fixedplugin-cmp></fixedplugin-cmp> -->\n"


//////////////////
// WEBPACK FOOTER
// /Users/maikelbald/laboratorio/NossaCidadeMelhor/angular-app/src/app/layouts/no-auth/no-auth.component.html
// module id = ../../../../../src/app/layouts/no-auth/no-auth.component.html
// module chunks = 5